import {AuthorizationFetcher, FetcherUtils, utils} from '@wallaby-ui/core';
import {isEmpty, omit} from 'lodash';
import {LIBRARY_NAME} from 'src/js/common/constants';
import {GRID_SORT_MODEL_SORT_COLUMN, GRID_SORT_MODEL_SORT_DIRECTION} from 'src/js/containers/grid/grid_constants';

import {DEFAULT_PAGE_SIZE} from '../common';

const logger = utils.LogUtils.getLogger('CaseFetcher', LIBRARY_NAME);

/** @deprecated */
const CaseFetcher = {
  get(requestUrl, caseId) {
    if (!requestUrl || !caseId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, caseId: ${caseId}`);
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(caseId)}?projection=detail`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(FetcherUtils.processJsonResponse)
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },

  getDocuments(requestUrl, caseId, params) {
    if (!requestUrl || !caseId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, caseId: ${caseId}`);
    }
    const sortParams =
      params.sort && params.sort.length > 0
        ? params.sort
            .map((sortItem) => `sort=${sortItem[GRID_SORT_MODEL_SORT_COLUMN]},${sortItem[GRID_SORT_MODEL_SORT_DIRECTION]}`)
            .join('&')
        : '';

    const newParams = {
      ...omit(params, 'sort'),
      page: params.page - 1,
      size: DEFAULT_PAGE_SIZE,
      projection: 'list',
    };
    const searchParams = FetcherUtils.transformJSONToUrlEncodedParams(newParams);
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(caseId)}?${searchParams}${isEmpty(sortParams) ? '' : `&${sortParams}`}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(FetcherUtils.processJsonResponse)
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },

  getHierarchyNode(requestUrl, caseId) {
    if (!requestUrl) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}`);
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}?caseId=${encodeURIComponent(caseId)}&projection=tree`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getTimeline(requestUrl, caseId, timelineMethod) {
    if (!requestUrl || !caseId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, caseId: ${caseId}`);
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(caseId)}/${timelineMethod}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getReports(requestUrl, caseId, reportsMethod, params) {
    if (!requestUrl || !caseId) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}, caseId: ${caseId}`);
    }
    const reportId = params.reportId || '';
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(caseId)}/${reportsMethod}/${reportId}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default CaseFetcher;
